import React from "react";

type SubmitButtonProps = {
    submitting: boolean,
    name: string,
    submittingName: string,
    onClick: any,
    className: string,
}

const SubmitButton = ({
    submitting,
    name,
    submittingName,
    onClick,
    className,
}: SubmitButtonProps) => {
    const defaultClassName = "btn btn-primary block full-width m-b focus:outline-none focus:ring focus:ring-charcoal-300";

    return (
        <button
            type="submit"
            disabled={submitting}
            className={defaultClassName}
            onClick={onClick}
            id="SubmitButton"
        >
            {submitting ? submittingName : name}
        </button>
    );
};

export default SubmitButton;